import { Type } from 'class-transformer';

import { SurveyModel as BaseSurveyModel } from '@empathy/survey/base';

import { PageModel } from './page.model';
import { Question } from './question.model';

export class SurveyModel extends BaseSurveyModel {
  @Type(() => PageModel)
  override pages: PageModel[];

  override get questions(): Question[] {
    return this.pages.reduce((questions, page) => (questions = [...questions, ...page.questions]), []);
  }
}
